export const commonFooterLinks = (t) => [
    {
        label: 'info@acclym.com',
        link: 'mailto:info@acclym.com',
    },
    {
        label: t('footer.privacy'),
        link: t('footer.links.privacy', 0, { redirectorUrl: window.location.href }),
    },
    {
        label: t('footer.terms'),
        link: t('footer.links.terms', 0, { redirectorUrl: window.location.href }),
    },
];
